import React from 'react';
export function Footer() {
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  return <footer className="bg-matte text-cream py-20" data-id="element-15">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8 mb-16" data-id="element-17">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-18">
            <div className="flex items-center gap-3 mb-6" data-id="element-19">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-cream" data-id="element-20">
                <path d="M12 2C12 2 8 6 8 12C8 18 12 22 12 22C12 22 16 18 16 12C16 6 12 2 12 2Z" fill="currentColor" opacity="0.8" data-id="element-21" />
                <circle cx="9" cy="8" r="1.5" fill="currentColor" data-id="element-22" />
                <circle cx="15" cy="8" r="1.5" fill="currentColor" data-id="element-23" />
                <circle cx="12" cy="6" r="1.5" fill="currentColor" data-id="element-24" />
              </svg>
              <span className="font-serif text-2xl tracking-wider" data-id="element-25">
                TERRA VET
              </span>
            </div>
            <p className="text-cream/60 max-w-sm mb-8" data-id="element-26">
              Medicina veterinaria de autor. Cuidamos a quienes más quieres con
              la excelencia y dedicación que merecen.
            </p>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-block bg-olive hover:bg-olive-light text-cream px-6 py-3 text-xs tracking-widest uppercase transition-colors duration-300" data-id="element-27">
              Reservar Turno
            </a>
          </div>

          {/* Contact */}
          <div data-id="element-28">
            <h4 className="font-serif text-xl mb-6" data-id="element-29">Contacto</h4>
            <ul className="space-y-4 text-cream/60" data-id="element-30">
              <li data-id="element-31">Av. del Libertador 1234</li>
              <li data-id="element-32">Buenos Aires, Argentina</li>
              <li data-id="element-33">+54 9 299 519-2151</li>
              <li data-id="element-34">hola@terravet.com</li>
            </ul>
          </div>

          {/* Links */}
          <div data-id="element-35">
            <h4 className="font-serif text-xl mb-6" data-id="element-36">Enlaces</h4>
            <ul className="space-y-4 text-cream/60" data-id="element-37">
              <li data-id="element-38">
                <a href="#servicios" className="hover:text-cream transition-colors" data-id="element-39">
                  Servicios
                </a>
              </li>
              <li data-id="element-40">
                <a href="#equipo" className="hover:text-cream transition-colors" data-id="element-41">
                  Equipo
                </a>
              </li>
              <li data-id="element-42">
                <a href="#testimonios" className="hover:text-cream transition-colors" data-id="element-43">
                  Testimonios
                </a>
              </li>
              <li data-id="element-44">
                <a href="#" className="hover:text-cream transition-colors" data-id="element-45">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-cream/40" data-id="element-46">
          <p data-id="element-47">
            &copy; {new Date().getFullYear()} Terra Vet. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6" data-id="element-48">
            <a href="#" className="hover:text-cream transition-colors" data-id="element-49">
              Privacidad
            </a>
            <a href="#" className="hover:text-cream transition-colors" data-id="element-50">
              Términos
            </a>
          </div>
        </div>
      </div>
    </footer>;
}